import '@hapana/shared/utils/type-defs.util'

/** @type {Styles} */
export const styles = {
  dialogContent: { padding: 0 },
  searchRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '& > form': { width: '100%' },
  },
  divider: { height: '8px', backgroundColor: 'gray.3' },
  content: { paddingY: 2.5, paddingX: 4 },
  centeredLoading: { display: 'flex', justifyContent: 'center', py: 2 },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 2.25,
  },
  filtersRow: { display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' },
  list: { display: 'flex', flexDirection: 'column' },
  listItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '&:not(:first-child)': { borderTop: '1px solid', borderColor: 'gray.12' },
    paddingTop: 3,
    paddingBottom: 3.5,
  },
  personInfo: { display: 'flex', alignItems: 'center', gap: 2 },
  personDetails: { display: 'flex', flexDirection: 'column', gap: 0.5 },
  equipmentChipContainer: { marginTop: 1.5 },
  actions: { display: 'flex', alignItems: 'center', gap: 1 },
}
